
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-27 -14 54 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M-27-14h54v36h-54z"}}),_c('path',{attrs:{"fill":"#dc171d","d":"M-6-14H6v36H-6z"}}),_c('path',{attrs:{"fill":"#012a87","d":"M-27-2h54v12h-54z"}}),_c('g',{attrs:{"id":"c","fill":"#fff","transform":"scale(1.5)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","transform":"rotate(18 3.157 -.5)","d":"M0 0v1h.5z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-144)"}})]),_c('g',{attrs:{"id":"d"}},[_c('use',{attrs:{"xlink:href":"#c","transform":"translate(8 3.314)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(3.314 8)"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(-1 1)"}})])
          )
        }
      }
    